import 'mapbox-gl/dist/mapbox-gl.css';
import './styles/_styles.scss';

import { useCMSQuery } from 'hooks/useCMSQuery';
import { useGetLocale } from 'hooks/useGetLocale';
import { libUIComponentsComponents, useLibUIComponentsLogin, useLibUIComponentsLogout } from 'libUIComponents';
import { observer } from 'mobx-react-lite';
import { LibUIComponentsProvider } from 'petdna-lib-uicomponents/providers';
import React, { useCallback, useMemo, useRef } from 'react';
import { CookiesProvider } from 'react-cookie';
import { Helmet } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { RouterProvider } from 'react-router-dom';
import { useStores } from 'stores/useStores';

import petdnaRouter from './routes';

const App = observer(() => {
  useGetLocale();
  const mainContainerRef = useRef<HTMLDivElement>(null);

  const updateBg = useCallback(() => {
    if (mainContainerRef.current) {
      if (window.location.pathname.includes('recollect-confirmation')) {
        mainContainerRef.current.style.background = '#E9FEB2';
      } else {
        mainContainerRef.current.style.background = '#F1EFEA';
      }
    }
  }, []);

  const router = useMemo(() => petdnaRouter({ updateBg }), [updateBg]);

  const { sessionStore: { sessionValid } } = useStores();

  return (
    <CookiesProvider>
      <LibUIComponentsProvider
        components={libUIComponentsComponents}
        isClient
        sessionValid={sessionValid}
        useLogin={useLibUIComponentsLogin}
        useLogout={useLibUIComponentsLogout}
        useCMSQuery={useCMSQuery}
      >
        <Toaster />
        <div className="d-flex flex-column min-vh-100" ref={mainContainerRef}>
          <RouterProvider router={router} />
        </div>
      </LibUIComponentsProvider>
    </CookiesProvider>
  );
});

export default App;
